/** The objective filter's value for findings that name no objective at all. */
export const UNASSIGNED_OBJECTIVE = 'unassigned';
